/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */

/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/remote-desktop-exercise/v0.ts
 */
import { createValidator } from '../../helpers/validator';
export var RemoteDesktopExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    hint: {
      type: 'string'
    },
    possible_answers: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    feedbacks: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  },
  required: ['title', 'xp', 'course_id', 'chapter_id', 'assignment', 'hint', 'possible_answers', 'feedbacks'],
  definitions: {}
};
export var isValidRemoteDesktopExerciseV0 = createValidator(RemoteDesktopExerciseV0Schema);
export var RemoteDesktopExerciseV0Definition = {
  schema: RemoteDesktopExerciseV0Schema,
  validate: isValidRemoteDesktopExerciseV0
};